import noop from '@gaia/util/noop/action'
import submitFavorite from 'app/_shared/action/favorite/submit'
import successFavorite from 'app/_shared/action/favorite/success'
import detail from './action/detail'
import edit from './action/edit'
import submit from './action/submit'
import index from './action/index'
import create from './action/create'

export default {
  index,
  new: create,
  edit,
  detail,
  submit,
  requests: noop,
  serviceitems: noop,
  contacts: noop,

  submitFavorite,
  successFavorite,
}
